import React, { createContext, useContext, useState } from 'react';
import { selectedProjectAtom } from 'atoms/projects';
import { useSetAtom } from 'jotai';

interface IContextProps {
  projectDetails: Object;
  updateGanttProject: boolean;
  updateProject: (values: Object) => void;
  updateUtils: (values: Object) => void;
  projectDashboardUtils: object;
  handleUpdateGanttProject: () => void;
}

const projectDetailsContext = createContext({} as IContextProps);
export const useProjectDetails = () => useContext(projectDetailsContext);

export const ProjectProvider = ({ children }: { children: React.ReactNode }) => {
  const [projectDetails, setProjectDetails] = useState<{}>();
  const [projectDashboardUtils, setprojectDashboardUtils] = useState<{}>();
  const [updateGanttProject, setUpdateGanttProject] = useState<boolean>(true);
  const setSelectedProject = useSetAtom(selectedProjectAtom);

  const updateProject = (values) => {
    setSelectedProject(values);
    setProjectDetails(values);
  };

  const updateUtils = (values) => {
    setprojectDashboardUtils(values);
  };

  const handleUpdateGanttProject = () => {
    setUpdateGanttProject((prev) => !prev);
  };

  return (
    <projectDetailsContext.Provider
      value={{
        projectDetails,
        updateGanttProject,
        projectDashboardUtils,
        updateProject,
        updateUtils,
        handleUpdateGanttProject,
      }}
    >
      {children}
    </projectDetailsContext.Provider>
  );
};
